<template>
    <div class="hongbao-wrapper" :class="[isOpened && 'opened', hbData && hbData.amount && 'has-amount', isDrawed && 'drawed']" v-if="hbData">
        <div class="hongbao-inner" v-show="!isDrawing">
            <div class="hongbao-img" :class="[isOpening && 'opening']" @click="open">
                <img v-show="!isOpened" src="../assets/img/open_hb.png" alt="">
                <img v-show="isOpened" src="../assets/img/hb_bg.png" alt="">
                <span v-if="isOpened">{{!hbData.amount ? '祝福红包' : '￥' + hbData.amount}}</span>
            </div>
            <p>{{isOpened ? !hbData.amount ? blessing : '恭喜你，拆开一个现金红包！' : '点击拆开红包！'}}</p>
            <div class="btns" v-if="isOpened">
                <p class="btn" @click="back"><span>返回首页</span></p>
                <p class="btn" @click="share"><span>分享你的幸运</span></p>
            </div>
        </div>
        <div class="share-drawing" v-show="isDrawing">
            分享图片生成中，请稍后...
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Draw from '@/utils/draw'
import COVERAPP from '@/utils/COVERAPP'

@Options ({
    data () {
        return {
            isOpening: false,
            isOpened: false,
            hbData: null,
            blessings: ['这一年，有你的陪伴才特别温暖！', '2020跟封面一起成长，2021继续与封面前行。', '下一年，继续跟着封面一路走红吧！', '封面想做你的记录者，2021继续陪着你。', '看见封面的力量，看见自己的小幸福。', '喜欢美好，喜欢陪伴，一起加油呀！', '在封面，体会平凡的可贵，生活的美好。', '你不孤独，在封面会遇见很多有趣儿的人。'],
            blessing: '',
            isDrawing: false,
            isDrawed: false,
            imgUrl: '',
            tags: ['封面新人', '进阶担当', '忠实粉丝', 'C位挚友']
        }
    },
    props: ['data'],
    computed: {
        ...mapState(['aid', 'shareData', 'userInfo', 'yearData'])
    },
    created () {
        this.SET_HBDATA(true)
        this.hbData = this.data == true ? null : this.data
        if (!this.hbData) {
            this.getHb()
        }
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_HBDATA']),
        open () {
            if (!this.isOpened && this.hbData.amount) {
                if (this.isOpening) return
                this.isOpening = true
                this.$request('/lottery/cash', {
                    aid: this.aid,
                    pid: this.hbData.pid
                }, 'put').then((data: any) => {
                    this.isOpened = true
                    this.isOpening = false
                }).catch((res: any) => {
                    if (res && res.errno == 1001 && res.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                        this.SET_DIALOGDATA({
                            text: '您的微信未实名认证，不能领取红包，<br>请实名认证后领取',
                            btns: [
                                {
                                    text: '确定'
                                }
                            ]
                        })
                    } else if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010)) {
                        this.$common.toast('加载失败，请重试！')
                    }
                    this.isOpening = false
                })
            } else {
                this.isOpened = true
            }
            this.$common.track(this.aid, 'click', '拆红包')
        },
        getHb () {
            this.blessing = this.blessings[Math.floor(Math.random() * this.blessings.length)]
            this.$request('/lottery/luck', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                data.amount = (data.amount / 100).toFixed(2)
                this.hbData = data
            }).catch(() => {
                this.hbData = {}
            })
        },
        back () {
            this.$common.track(this.aid, 'click', '返回首页')
            this.$router.push({
                path: '/'
            })
        },
        share () {
            const _this = this
            _this.isDrawing = true
            this.isDrawed = true
            if (_this.imgUrl) {
                _this.shareImage(_this.imgUrl)
                return
            }
            if (this.yearData) {
                new Draw({
                    times: this.yearData.use_count,
                    days:  this.yearData.use_days,
                    news: this.yearData.news_read_cnt,
                    integrals: this.yearData.score_get_num || 0,
                    tag: this.tags[this.yearData.grade - 1],
                    amount: (this.hbData && this.hbData.amount) || 0,
                    sucessCallback (url: string) {
                        _this.imgUrl = url
                        _this.shareImage(_this.imgUrl)
                        _this.isDrawing = false
                    },
                    errCallback () {
                        _this.isDrawing = false
                    }
                })
            } else {
                new Draw({
                    noData: true,
                    amount: (this.hbData && this.hbData.amount) || 0,
                    sucessCallback (url: string) {
                        _this.imgUrl = url
                        _this.shareImage(_this.imgUrl)
                        _this.isDrawing = false
                    },
                    errCallback () {
                        _this.isDrawing = false
                    }
                })
            }      
        },
        shareImage (url: string) {
            const _this = this
            COVERAPP.Method.shareImage({
                title: _this.shareData.title,
                desc: _this.shareData.desc,
                imgUrl: _this.shareData.imgUrl,
                link: _this.shareData.link,
                image: url.split(';base64,')[1],
                callback () {
                    _this.$common.track(_this.aid, 'share', '分享图片')
                }
            })
            _this.isDrawing = false
        }
    }
})
export default class HongBao extends Vue {}
</script>

<style lang="scss">
.hongbao-wrapper {
    background-color: rgba($color: #000000, $alpha: .5);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(10px);
    z-index: 30;
    display: flex;
    align-items: center;
    justify-content: center;
    .hongbao-inner {
        width: 100%;
        box-sizing: border-box;
        padding: 0 1.388889rem;
        animation: zoomInDown 1s forwards;
        .hongbao-img {
            width: 4.851852rem;
            margin: 0 auto .462963rem;
            font-size: 0;
            &.opening {
                animation: openHb ease-in-out 2s infinite;
            }
        }
        p {
            font-size: .462963rem;
            color: #ffffff;
            text-align: center;
            line-height: 1.4;
            letter-spacing: 2px;
        }
        .btns {
            display: flex;
            justify-content: space-between;
            .btn {
                height: .888889rem;
                display: inline-flex;
                justify-content: center;
                background: linear-gradient(#fd4144, #d7151b);
                border-radius: .444444rem;
                width: 3.222222rem;
                align-items: center;
                position: relative;
                cursor: pointer;
                text-decoration: none;
                &::before {
                    content: '';
                    position: absolute;
                    left: .12963rem;
                    top: .083333rem;
                    width: .694444rem;
                    height: .277778rem;
                    background: url('../assets/img/btn_light.png') no-repeat left top;
                    background-size: 100% 100%;
                }
                span {
                    font-size: .407407rem;
                    color: #fff;
                    line-height: 1.4;
                    letter-spacing: .046296rem;
                }
            }
        }
    }
    &.opened {
        .hongbao-inner {
            animation-name: none;
            .hongbao-img {
                width: 3.453704rem;
                position: relative;
                margin-bottom: .87963rem;
                animation: bounceIn 1.5s forwards;
                span {
                    color: #ffdc00;
                    font-size: .37037rem;
                    position: absolute;
                    line-height: 1.4;
                    top: 3.240741rem;
                    left: 50%;
                    transform: translateX(-50%);
                    &.has-amount {
                       font-size: .555556rem; 
                    }
                }
            }
            p {
                font-size: .425926rem;
                margin-bottom: .925926rem;
            }
        }
        &.drawed {
            .hongbao-inner {
                .hongbao-img {
                    animation-name: none;
                }
            }
        }
    }
    .share-drawing {
        color: #fff;
        font-size: .425926rem;
    }
}

@keyframes openHb{
    0% {
        transform: rotateY(0deg)
    }
    100% {
        transform: rotateY(360deg)
    }
}

</style>